import { useCallback, useMemo } from 'react';

import { useIsWorkspaceAgentPanelAvailable } from '~/components/v2/components/workspace/workspace-agent-panel/hooks/useIsWorkspaceAgentPanelAvailable';
import { useWorkspaceMembersContext } from '~/providers/WorkspaceMembersProvider';
import { formatFirstLastInitial } from '~/utils/formatFirstLastInitial';

export const useWorkspaceAgentTaskCreatorDisplay = () => {
  const { canViewAllAgentSessions } = useIsWorkspaceAgentPanelAvailable();
  const { data: members } = useWorkspaceMembersContext();

  const memberNameById = useMemo(() => {
    const map = new Map<string, string>();

    for (const member of members ?? []) {
      if (member.accountId) {
        map.set(member.accountId, formatFirstLastInitial(member.firstName, member.lastName));
      }
    }

    return map;
  }, [members]);

  const getCreatorName = useCallback(
    (accountId: string | undefined) => (accountId ? memberNameById.get(accountId) : undefined),
    [memberNameById],
  );

  return {
    showCreatedBy: canViewAllAgentSessions,
    getCreatorName,
  };
};
